import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import { FaCloudDownloadAlt } from "react-icons/fa";
import axios from "axios";
import Select from "react-select";

const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const customRequireStyles = {
  control: (base) => ({ ...base, borderColor: "red" }),
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const AddCatalogue = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sizeDrp, setSizeDrpData] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    name: "",
    file: null,
    pdf_url: "",
    image: null,
    image_url: "",
    size_id: "",
  });

  const getSizeData = () => {
    axios.post(API_URL.SIZE_LIST, {}).then((res) => {
      setSizeDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setSizeDrpData(cd);
    });
  };

  const onSave = () => {
    if (formData.name && formData.size_id && formData.image && formData.pdf_url) {
      setError(false);
      setLoading(true);
      var prodFormData = new FormData();
      if (id) {
        prodFormData.append("id", id);
      }
      if (formData.image) {
        prodFormData.append("image", formData.image);
      }
      if (formData.size_id) {
        prodFormData.append("size_id", formData.size_id);
      }
      if (formData.file) {
        prodFormData.append("file", formData.file);
      }
      if (formData.name) {
        prodFormData.append("name", formData.name);
      }
      const pUrl = id ? API_URL.CATALOGUE_UPDATE : API_URL.CATALOGUE_SAVE;
      axios.post(pUrl, prodFormData).then((res) => {
        if (res.data.status === 1) {
          let message = id
            ? "Catalogue Updated Successfully."
            : "Catalogue Created Successfully.";
          toast.success(message, { autoClose: 3000, position: "top-right" });
          setLoading(false);
          navigate("/admin/catalogue");
        }
      }).catch((error) => {
        setError(false);
        setLoading(false);
      }).finally(() => {
        setError(false);
        setLoading(false);
      });
    } else {
      setError(true);
      setLoading(false);
    }
  };

  const onEdit = () => {
    axios.post(API_URL.CATALOGUE_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          file: res.data.data.file ? res.data.data.file : "",
          pdf_url: res.data.data.pdf_url ? res.data.data.pdf_url : "",
          image: res.data.data.image ? res.data.data.image : "",
          image_url: res.data.data.image_url ? res.data.data.image_url : "",
          size_id: res.data.data.size_id ? res.data.data.size_id : "",
        });
      }
    });
  };

  const isRequiredField = (key) => {
    return isError && !formData[key];
  };

  useEffect(() => {
    getSizeData();
  }, []);

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{id ? "Update" : "Add"} Catalogue</h5>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <form>
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="form-group">
                  <label>Name<span className="required-star">*</span></label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    className={
                      isRequiredField("name")
                        ? "form-control required"
                        : "form-control"
                    }
                    id="name"
                    onChange={(event) => {
                      setFormData({ ...formData, name: event.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="form-group">
                  <label htmlFor="Size">Size<span className="required-star">*</span></label>
                  <Select
                    options={sizeDrp}
                    placeholder=""
                    value={sizeDrp.find((r) => r.value == formData.size_id)}
                    styles={
                      isRequiredField("size_id")
                        ? customRequireStyles
                        : customStyles
                    }
                    onChange={(e) =>
                      setFormData({ ...formData, size_id: e.value })
                    }
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 position-relative">
                <div className="form-group">
                  <label>PDF<span className="required-star">*</span></label>
                  <input
                    className={
                      isRequiredField("file")
                        ? "form-control required"
                        : "form-control"
                    }
                    accept="application/pdf"
                    disabled={id}
                    name="file"
                    type="file"
                    id="file"
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        setFormData({
                          ...formData,
                          file: e.target.files[0],
                        });
                      }
                    }}
                  />
                  {id && formData.pdf_url && (
                    <a
                      className="pdf-view-icon"
                      href={formData.pdf_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaCloudDownloadAlt size={20}></FaCloudDownloadAlt>
                      &nbsp;Download
                    </a>
                  )}
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Image<span className="required-star">*</span></label>
                      <input
                        type="file"
                        name="image"
                        className={
                          isRequiredField("image")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="image"
                        onChange={(event) => {
                          if (event.target.files && event.target.files[0]) {
                            setFormData({
                              ...formData,
                              image: event.target.files[0],
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                  {id && formData.image_url && (
                    <div className="col-md-12">
                      <div>
                        <a
                          href={formData.image_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={formData.image_url}
                            height={100}
                            width={100}
                            alt="post_image"
                          />
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                <div className="text-end">
                  <Link
                    to={"/admin/catalogue"}
                    className={
                      loading
                        ? "btn btn-danger btn-sm me-2 disabled-link"
                        : "btn btn-danger btn-sm me-2"
                    }
                    onClick={(e) => loading && e.preventDefault()}
                  >
                    Cancel
                  </Link>
                  <button
                    type="button"
                    onClick={onSave}
                    disabled={loading}
                    className="btn btn-primary btn-sm"
                  >
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      {loading && (
                        <Watch color={"white"} height={15} width={15} />
                      )}
                      Submit
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddCatalogue;
